var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoOverdue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".b{letter-spacing:.1em;}.c{fill:#9c0f18;}.c,.d{mix-blend-mode:multiply;}.d,.e{fill:#414042;}.e{font-family:AvenirNextCondensed-Bold, Avenir Next Condensed;font-size:170px;}.f{letter-spacing:.09em;}.g{isolation:isolate;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "446.54 351.76 446.55 194.02 377.95 254.82 377.95 412.56 446.54 351.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "c",
    points: "532.64 254.09 600.43 194.02 446.55 194.02 378.77 254.09 532.64 254.09"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "553.45 276.45 553.45 434.19 622.05 373.39 622.05 215.65 553.45 276.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "d",
    points: "467.35 374.12 399.57 434.19 553.45 434.19 621.22 374.12 467.35 374.12"
  })), /*#__PURE__*/React.createElement("text", {
    className: "e",
    transform: "translate(122.83 613.73)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "f",
    x: 0,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "b",
    x: 120.02,
    y: 0
  }, "VERDUE"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOverdue);
export default __webpack_public_path__ + "static/media/logo-overdue.708057650b50486af8daaacb13555fa6.svg";
export { ForwardRef as ReactComponent };